import * as React from 'react';
import { FC, ChangeEvent } from 'react';
import Button, { FILLED_BUTTON_TYPE_DARK } from 'components/Button/Button';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { search_hotels } from 'data/translationKeys';
import { useMediaQuery } from '@mui/material';
import { breakpoints } from 'data/constants';
import { MobileSearchDialog } from './MobileSearchDialog';
import SuggestionsDropdown from './SuggestionsDropdown';
import { useSearchBarContext } from './context';
import { SEARCH_INPUT_NAME } from './constants';
import TextInput from './TextInput';
import { useRouter } from 'next/router';
import type { InspirationType } from 'types/types';
import useDropdown from 'hooks/useDropDown';

interface IInspirationItem {
  inspirationCategories: InspirationType[];
}

const SearchBar: FC<IInspirationItem> = ({ inspirationCategories }) => {
  const { state, setState } = useSearchBarContext();
  const { searchInputValue, urlObject } = state;
  const router = useRouter();
  const { isOpen, dropdownRef, setIsOpen } = useDropdown<HTMLDivElement>();

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setState({ searchInputValue: e.target.value });
  };

  const resetInputField = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setState({ searchInputValue: '' });
  };

  const handleSearchInputFocus = () => {
    if (isOpen) {
      return;
    }
    setState({ showSearchSuggestions: true, showInspirationCategories: true });
    setIsOpen(true);
  };

  const handleSearchClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    if (!urlObject) {
      return;
    }

    router.push(urlObject);
  };

  const search_hotels_text = useLocalised(search_hotels);

  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm})`);

  return (
    <div className="search-input" ref={dropdownRef}>
      <div className="search-input__container">
        <div className="search-input__section">
          <div className="search-input__text-field">
            <TextInput
              name={SEARCH_INPUT_NAME}
              onFocus={handleSearchInputFocus}
              value={searchInputValue}
              onChange={handleChange}
              resetInputField={resetInputField}
            />
            {isMobile && (
              <MobileSearchDialog
                {...{ handleChange, resetInputField }}
                inspirationCategories={inspirationCategories}
              />
            )}
            {isOpen && !isMobile && (
              <SuggestionsDropdown
                inspirationCategories={inspirationCategories}
              />
            )}
          </div>
          <Button
            title={search_hotels_text}
            onClick={handleSearchClick}
            className="search-input__button"
            buttonType={FILLED_BUTTON_TYPE_DARK}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
